import React from 'react';
import {Skeleton, Stack, Typography} from '@mui/material';

/**
 * Empty state component for the table
 * @param {boolean} loading - Whether data is loading
 * @param {number} reportCount - Number of reports
 */
const EmptyState = ({loading, reportCount}) => {
    if (loading) {
        return (
            <>
                {[...Array(5)].map((_, i) => (
                    <Stack key={i} direction="row" spacing={2} px={2} py={2} bgcolor="white">
                        <Skeleton variant="text" sx={{flex: 1}} />
                        <Skeleton variant="text" sx={{flex: 1}} />
                        <Skeleton variant="text" sx={{flex: 1}} />
                        <Skeleton variant="text" sx={{flex: 1}} />
                        <Skeleton variant="text" sx={{flex: 1}} />
                    </Stack>
                ))}
            </>
        );
    }

    if (reportCount === 0) {
        return <Typography px={2} py={2}>No reports found.</Typography>;
    }

    return null;
};

export default EmptyState;
